import VueRouter from 'vue-router'

// Routes
const routes = [

    {
        path: '/login',
        name: 'login',
        component: () => import('./pages/Login'),
    },

    {
        path: '/',
        name: 'entry',
        redirect: 'home'
    },

    // public area
    /*{
        path: '/test/',
        component: () => import('./pages/Tests/Editor'),
    },*/
    // public area
    {
        path: '/document/',
        component: () => import('./templates/Document'),
        children: [
            {
                path: '/document/text/:document_node_id/:node_id?',
                name: 'text-document',
                component: () => import('./pages/Documents/Editor'),
            }
        ]
    },

    // public area
    {
        path: '/',
        component: () => import('./templates/Public'),
        children: [
            {
                path: '/home/:year?/:month?/:day?',
                name: 'home',
                component: () => import('./pages/Home'),
            },

            {
                path: '/users-report',
                name: 'users-report',
                component: () => import('./pages/Reports/UsersProjectsMonthReport'),
            },

            {
                path: '/users-report-details/:year/:month/:day/:user_id',
                name: 'user-report-details',
                component: () => import('./pages/Reports/UsersDetailedMonthReport'),
            },

            {
                path: '/logout',
                name: 'logout',
                component: () => import('./components/Logout'),
            },

            {
                path: '/profile',
                name: 'profile',
                component: () => import('./pages/Profile'),
            },

            // Task redirector
            {
                path: '/task/:task_id?', redirect: to => {
                    // the function receives the target route as the argument
                    // return redirect path/location here.
                    return {name: 'tree', params: {task_id: to.params.task_id}}
                }
            },

            {
                path: '/tree/:task_id?/:mode?',
                name: 'tree',
                component: () => import('./pages/Tree/Tree')
            },

            {
                path: '/search/:query?/:task_id?',
                name: 'search',
                component: () => import('./pages/Tree/components/Search/SearchResults')
            },
            {
                path: '/table/:task_id?',
                name: 'table',
                component: () => import('./pages/Tree/Table')
            },
            {
                path: '/users',
                name: 'users',
                component: () => import('./pages/Users')
            },
            {
                path: '/positions',
                name: 'positions',
                component: () => import('./pages/Positions')
            },
            {
                path: '/hr',
                name: 'hr',
                component: () => import('./pages/HR/HR')
            },
            {
                path: '/hr/user-load',
                name: 'users-load',
                component: () => import('./pages/HR/UserLoad')
            },
        ],
    },
    {
        path: '/404',
        name: '404',
        component: () => import('./pages/404'),
    }
];

const router = new VueRouter({
    history: true,
    mode: 'history',
    routes,
});

export default router
